import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchPagination, SearchResults } from '@uncinc/react-searchkit';

import { SearchAllContentHit } from '../types';
import Hit from './Hit';

const SearchAllContentResults: React.FC = () => {
  const { t } = useTranslation();

  const classNames = c('SearchAllContent__Results');

  return (
    <>
      <SearchResults
        className={classNames}
        renderItem={(hit: SearchAllContentHit) => <Hit hit={hit} />}
      />
      <div className="mt-2">
        <SearchPagination
          previousLabel={t('buttons.previous')}
          nextLabel={t('buttons.next')}
        />
      </div>
    </>
  );
};

export default SearchAllContentResults;
